// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import OpenPipsSummary from '@deere/cps-it.warranty-model-factory/lib/open-pips-summary';
import OpenPipsSummaryItem from './open-pips-summary-item';

const OpenPipsSummaryList = props =>
    <ul className='open-pips-summary-list'>
        <OpenPipsSummaryItem
            className='dot-icon-red'
            count={props.openPipsSummary.expiredCount}
            status='EXPIRED'
        />
        <OpenPipsSummaryItem
            className='dot-icon-yellow'
            count={props.openPipsSummary.pinsExpiringInNext90Days}
            status='EXPIRING_SOON'
        />
        <OpenPipsSummaryItem
            className='dot-icon-transparent'
            count={props.openPipsSummary.currentPinsCount}
            status='CURRENT'
        />
    </ul>;

OpenPipsSummaryList.displayName = 'OpenPipsSummaryList';
OpenPipsSummaryList.propTypes = {
    openPipsSummary: PropTypes.instanceOf(OpenPipsSummary).isRequired
};

export default OpenPipsSummaryList;



// WEBPACK FOOTER //
// ./src/pip/open-pips/components/open-pips-aside/open-pips-summary/open-pips-summary-list.js